import { TalentPanelTranslations } from '@/assets/locales/components/talentPanel/talentPanel.translations.en';

export const talentPanelTranslations: TalentPanelTranslations = {
  area: 'Obszar lub stanowisko',
  areaMissing: 'Nie podano obszaru',
  areaPlaceholder: 'np. Lider Zespołu',
  cancelEdit: 'Anuluj edycję',
  close: 'Zamknij',
  date: 'Data panelu',
  edit: 'Edytuj wpis',
  editHeading: 'Edycja panelu',
  empty: 'Nie zapisano jeszcze żadnego panelu.',
  formHeading: 'Nowy panel',
  historyHeading: 'Poprzednie panele ({{total}})',
  loadError: 'Nie udało się wczytać poprzednich paneli. Zamknij okno i otwórz je ponownie.',
  outcome: 'Rezultat i wnioski',
  outcomeMissing: 'Nie podano wniosków',
  outcomePlaceholder: 'Wpisz wnioski z panelu...',
  save: 'Zapisz panel',
  saveChanges: 'Zapisz zmiany',
  saveError: 'Nie udało się zapisać panelu. Spróbuj ponownie.',
  title: 'Panel rozwojowy',
  updateError: 'Nie udało się zapisać zmian. Spróbuj ponownie.',
};
